import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import Money from '../../../Money/Money'
import Typography from '../../../Typography/Typography'
import { ALLOWED_PAYMENTS } from '../../constants'

import './Price.scss'
import BasketPriceReserve from './components/BasketPriceReserve'

const Price = ({ data, loading, onReserve, onBuy }) => {
    const intl = useIntl()
    const canReserve = data?.allowed_payments?.includes(ALLOWED_PAYMENTS.CASH)
    const onSitePriceExtra =
        data?.application_prices?.find((item) => item.application === 'Client')?.price - data?.price

    return (
        <>
            <div className={'basket-price d-flex justify-content-between'}>
                <div className="price-wrapper d-flex">
                    <Typography color={'basePrimary'} variant={'label'} className={'text-nowrap'}>
                        {intl.formatMessage({ id: 'basket.totalPrice' })}
                    </Typography>
                    <Typography color={'basePrimary'} variant={'bodyBold'} className={'text-nowrap'}>
                        <Money amount={data?.price} currency={data?.currency} />
                    </Typography>
                </div>
                <div className="btns-wrapper d-flex gap-3">
                    {canReserve && (
                        <BasketPriceReserve
                            onReserve={onReserve}
                            loading={loading}
                            amount={onSitePriceExtra}
                            currency={data?.currency}
                            className={'d-none d-md-flex'}
                        />
                    )}
                    <ButtonCinestar
                        variant={'primary-v1'}
                        onClick={onBuy}
                        disabled={loading}
                        className={'text-nowrap text-uppercase'}
                    >
                        {intl.formatMessage({ id: 'basket.buyBtn' })}
                    </ButtonCinestar>
                </div>
            </div>
        </>
    )
}

export default Price
